import React from "react"
import { Box } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

const ResultsDisclaimer = ({ data, className = ``, mt = [8, 8, 8] }) => {
  return (
    <Box mt={mt}>
      <TextElementNova
        text={data ? data : "Results are from a clinical study and may vary."}
        className={`Caption-10-Dia-Normal text-nova-transparency-black-70 ${className}`}
      />
    </Box>
  )
}

export default ResultsDisclaimer
